import { useState, useEffect, useContext } from 'react'
import classes from './DiscoverNow.module.css'
import Loader from '../Loader'
import { Container, Row, Column } from '../Shared/FlexDiv/FlexDiv'
//import AutoSuggest from '../Freightrates1/AutoComplete/AutoComplete'
import AutoComplete from '../Shared/AutosuggestV2/Autosuggestv2'
import { validateInputs, getRequestData, AxiosRequest } from './Utitlity'
import { Activity, ActivityString, currentRequestTimeStamp, isMobile, Constants } from '../../Constants'
import { toast } from 'react-toastify'
import TransporterList from './TransporterList/TransporterList'
import './style.css'
import Filters from './TransporterList/Filters'
import { useLocation } from 'react-router' // useHistory
import UpgradeModal from '../UpgradeModal/UpgradeModal'
import RatesModal from '../Shared/PopupModal/PopupModal'
import NewEnquiry from '../TrucksAvailable/NewEnquiry/NewEnquiry'
import ReactGA from 'react-ga'
import Pagination from 'react-js-pagination'
import { UserApiContext } from '../UserDetailsContext/UserDetailsContext';
import { closeModal } from '../Indent/InvoiceV2/utils'
import { useMixPanelForTracking } from '../../utils/TrackMixPanel'
import { MyCompanyProfileContext } from '../../MyCompanyProfileContext'

const UserHistoryList = ({ userHistory = [], historyArray = {}, populateLocations, TrackMixPanel }) => {
    return (
        <div className="" style={{ maxHeight: "300px", overflow: "auto" }}>
            {userHistory.map((history, index) => (
                <div className="d-flex justify-content-between mx-2 pr-4 my-2" key={index}>
                    <div className="d-flex align-items-center">
                        <span className='pr-2'>{index + 1}.</span>
                        <span>{history}</span>
                    </div>
                    <div className="">
                        <button
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                                TrackMixPanel({
                                    ModuleName: 'landing_page',
                                    ScreenName: 'LoRRI-Discovernow',
                                    Data: history,
                                    Definition: 'User has clicked view button on search history item'
                                })
                                populateLocations(historyArray[history])
                            }}
                        >
                            View
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

const DiscoverNow = () => {

    /* -------------------------------- Set defaults for searching -------------------------------- */

    const [origin, setOrigin] = useState({ location_name: 'Mumbai, Mumbai, Maharashtra', location: { location: 'Mumbai', lon: 72.8776559, lat: 19.0759837, 'label': 'Mumbai, Mumbai, Maharashtra' } })
    const [inputOrigin, setInputOrigin] = useState('Mumbai, Mumbai, Maharashtra')
    const [destination, setDestination] = useState({ location_name: 'Pune, Pune, Maharashtra', location: { location: 'Pune', lon: 73.5623575, lat: 18.5816211, 'label': 'Pune, Pune, Maharashtra' } })
    const [inputDestination, setInputDestination] = useState('Pune, Pune, Maharashtra')
    const { userDetails } = useContext(UserApiContext)
    const { companySettingData } = useContext(MyCompanyProfileContext)
    const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData)

    const [transporterData, settransporterData] = useState([])
    const [totalCount, setTotalCount] = useState(0)
    const [showFilters, setShowFilters] = useState(false)
    const [show, setShow] = useState(false)
    const [nooftransporters, setnooftransporters] = useState(0)
    // const [showHistory, setShowHistory] = useState(false)
    // const [responseData, setResponseData] = useState({})
    const [selectedFilters, setSelectedFilters] = useState([])
    const [availableFilters, setAvailableFilters] = useState([])
    // const [preferredTruck, setPreferredTruck] = useState('')
    const preferredTruck = ''
    // const [transitTime, setTransitTime] = useState('')
    const transitTime = ''
    const [credits, setcredits] = useState()
    const [userType, setuserType] = useState('basic')
    const [isAllowed, setisAllowed] = useState('no')
    const [isEntry, setisEntry] = useState(true)
    const [isFilterAllowed, setisFilterAllowed] = useState('yes')
    const [userHistory, setuserHistory] = useState([])
    const [historyArray, setHistoryArray] = useState([])
    const [selectedfield, setSelectedfield] = useState([])
    const [selectedfieldfetched, setSelectedfieldfetched] = useState([])
    // const [buttonState, setbuttonState] = useState(false)
    const [exhaushted, setExhaushted] = useState(false)
    // const [expanded, setExpanded] = useState(false)
    const [policydata, setpolicydata] = useState()
    const [fields, setFields] = useState({})
    const [skipactive, setskipactive] = useState(1)
    const location = useLocation()

    // const truckshistory = useHistory()

    useEffect(() => {
        document.title = 'LoRRI - DiscoverNow'
        ReactGA.pageview('DiscoverNow');
        TrackMixPanel({
            ModuleName: 'landing_page',
            ScreenName: 'LoRRI-Discovernow',
            Data: 'None',
            Definition: 'User has viewed discover now page'
        });
        setpolicydata(userDetails)
        // setuserType(props.userType)
        setuserType(userDetails?.policy?.type)
        if (userDetails?.policy?.type === 'basic') {
            setisFilterAllowed(false)
        }
        // console.log(props.userType)
        //setisAllowed(userDetails?.policy?.[Constants?.policies?.permission?.[`/${window.location.href.split('/').pop()}`]]['allowed'])
        setisFilterAllowed(userDetails?.policy?.discovernow?.filter_permission)
        setisAllowed(userDetails?.policy?.discovernow?.allowed ?? "no")
        // === "custom"
        // setisFilterAllowed(res.data.policy[Constants.policies.permission[`/${window.location.href.split('/').pop()}`]]['filter_permission'])
        // setcredits(res.data.policy[Constants.policies.permission[`/${window.location.href.split('/').pop()}`]][Constants.policies.credits[`/${window.location.href.split('/').pop()}`]])
        setcredits(userDetails?.policy?.discovernow?.allowed_searches ? userDetails?.policy?.discovernow?.allowed_searches : 0)
        var history = userDetails?.policy?.['discovernow']['search_history'] ? userDetails?.policy?.['discovernow']['search_history'] : null
        setuserHistory(history ? Object.keys(history) : [])
        setnooftransporters(userDetails?.policy?.discovernow?.lsp_limit)
        setHistoryArray(history ? history : [])

        settransporterData([])
        if (location.state ? location.state.from_search : null) {
            // console.log(location.state.data)
            setOrigin(location.state.data.origin)
            setInputOrigin(location.state.data.inputOrigin)
            setDestination(location.state.data.destination)
            setInputDestination(location.state.data.inputDestination)
            // getResults(location.state.data.origin, location.state.data.inputOrigin, location.state.data.destination, location.state.data.inputDestination);
            // setSelectedFilters(location.state.filter_discovernow)
            if (location.state.data.filter_discovernow[0].type) {
                // console.log("filter",location.state.data.filter_discovernow)
                setSelectedFilters(location.state.data.filter_discovernow)
                let request_data = getRequestData(origin,
                    inputOrigin,
                    destination,
                    inputDestination,
                    location.state.data.filter_discovernow,
                    // 0,
                    // transitTime,
                    // preferredTruck
                )

                // Activity([{ "screen": "DiscoverNow", "module": "Filter", "user_activity": { filter_data }, "timestamp": currentRequestTimeStamp() }])
                getTransportersList(request_data);
            }
            else {
                // console.log("no filter")
                getResults(location.state.data.origin, location.state.data.inputOrigin, location.state.data.destination, location.state.data.inputDestination);

            }
        }
        else {
            getResults(origin, inputOrigin, destination, inputDestination);
        }
        // old code
        // getResults(origin, inputOrigin, destination, inputDestination);
        // old code
        Activity([{ "screen": "DiscoverNow", "module": "DiscoverNow", "user_activity": ActivityString.DiscoverNowPageView, "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])

    }, [userDetails])

    const updateHistory = () => {
        // Assume that given location is new
        var isSearchedBefore = false
        for (var i = 0; i < userHistory.length; i++) {
            if (`${origin.location_name}_to_${destination.location_name}` === userHistory[i]) {
                isSearchedBefore = true
                break
            }
        }
        if (isSearchedBefore === false) {
            // if (credits > 0 && transporterData.length>0) {
            //     setcredits(credits - 1)
            // }
            var tempUserHistory = userHistory
            tempUserHistory.push(`${origin.location_name}_to_${destination.location_name}`)
            setuserHistory(tempUserHistory)

            var tempHistoryArray = historyArray
            tempHistoryArray[`${origin.location_name}_to_${destination.location_name}`] = {}

            var tempOriginCoordinates = []
            tempOriginCoordinates.push(origin.location ? origin.location.lon : "")
            tempOriginCoordinates.push(origin.location ? origin.location.lat : "")

            var tempOrigin = []
            tempOrigin.push({
                filter: 'origin',
                type: 'coordinates',
                label: origin.location ? origin.location.label : "",
                isChecked: false,
                value: tempOriginCoordinates
            })

            var tempDestinationCoordinates = []
            tempDestinationCoordinates.push(destination.location ? destination.location.lon : "")
            tempDestinationCoordinates.push(destination.location ? destination.location.lat : "")

            var tempDestination = []
            tempDestination.push({
                filter: 'destination',
                type: 'coordinates',
                label: destination.location ? destination.location.label : "",
                isChecked: false,
                value: tempDestinationCoordinates
            })

            tempHistoryArray[`${origin.location_name}_to_${destination.location_name}`]['origin'] = tempOrigin
            tempHistoryArray[`${origin.location_name}_to_${destination.location_name}`]['destination'] = tempDestination
            setHistoryArray(tempHistoryArray)
        }
    }

    const getTransportersList = (request_data, resetFilters) => {
        setExhaushted(false)

        setShow(true);
        AxiosRequest(request_data)
            .then(res => {
                setShow(false);
                if (res.data.client_status_error) {
                    // console.log(res.data.client_status_error)
                    toast.error('You do not have enough credits to discover more transporters!')
                    settransporterData([])
                    setTotalCount(0)
                    // setResponseData([])
                    setAvailableFilters([])
                    setSelectedfield([])
                }
                else {
                    settransporterData([])
                    setTotalCount(0)
                    // setResponseData([])
                    setAvailableFilters([])
                    setSelectedfield([])
                    settransporterData(res.data.transporter_list)
                    setTotalCount(res.data.transporters_count)
                    // setResponseData(res.data)
                    // console.log(res.data.filters)
                    if (res.data.filters && res.data.filters.length > 0) {
                        res.data.filters.map((item) => {

                            // if (item.filter === 'truck_type') {
                            setAvailableFilters(prevItem => [...prevItem, { label: `${item.type}`, value: item.type, ...item }])
                            // }
                        })
                    }

                    setFields(res.data.fields)
                    if (res.data.selected_field_list && res.data.selected_field_list.filters) {
                        res.data.selected_field_list.filters.map(val => {
                            if (val.filter === 'fields') {
                                setSelectedfieldfetched(val.value)
                            }
                        })
                    }
                    var data = res.data.transporter_list
                    var temp = []
                    for (var i = 0; i < data.length; i++) {
                        temp.push(data[i])
                    }
                    settransporterData(temp)
                    setcredits(userDetails?.policy?.discovernow?.allowed_searches)
                }

            })
            .catch(err => {
                settransporterData([])
                setTotalCount(0)
                // setResponseData([])
                setAvailableFilters([]);
                setShow(false)
            })
    }

    const getResults = (origin, inputOrigin, destination, inputDestination) => {
        setskipactive(1)
        if (isEntry) {
            if (validateInputs(origin, inputOrigin, destination, inputDestination, transitTime)) {
                let request_data = getRequestData(origin,
                    inputOrigin,
                    destination,
                    inputDestination,
                    [],
                    [],
                    0,
                    transitTime,
                    preferredTruck)

                let searched_data = {
                    origin: inputOrigin,
                    destination: inputDestination
                }
                Activity([{ "screen": "DiscoverNow", "module": "Search", "user_activity": { searched_data }, "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])
                TrackMixPanel({
                    ModuleName: 'landing_page',
                    ScreenName: 'LoRRI-Discovernow',
                    Data: JSON.stringify(searched_data),
                    Definition: 'User has clicked search lane button'
                });
                setSelectedFilters([])
                getTransportersList(request_data);
                setisEntry(false)
            }

        }
        else {

            /* Code for validating and serching lanes for origin and destination given */

            if (validateInputs(origin, inputOrigin, destination, inputDestination, transitTime)) {
                let request_data = getRequestData(origin,
                    inputOrigin,
                    destination,
                    inputDestination,
                    [],
                    [],
                    0,
                    transitTime,
                    preferredTruck)

                let searched_data = {
                    origin: inputOrigin,
                    destination: inputDestination
                }
                Activity([{ "screen": "DiscoverNow", "module": "Search", "user_activity": { searched_data }, "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])
                TrackMixPanel({
                    ModuleName: 'landing_page',
                    ScreenName: 'LoRRI-Discovernow',
                    Data: JSON.stringify(searched_data),
                    Definition: 'User has clicked search lane button'
                });
                setSelectedFilters([])
                getTransportersList(request_data);
                if (credits > 0) {
                    updateHistory()
                }

            }
        }
    }

    const populateLocations = (locationToSearch) => {

        closeModal("closeHistoryPopup");

        // Store data of `locationToSearch` in local variable
        let location = locationToSearch

        // Validate whether user has requested for ALL location as a ORIGIN
        if (location.origin.length === 0) {
            var temp = []
            temp.push({ label: 'ALL', value: [] })
            location.origin = temp

            setOrigin({ location_name: location.origin[0].label, location: { 'label': location.origin[0].label } })
            var tmpOrigin = { location_name: location.origin[0].label, location: { 'label': location.origin[0].label } }

            setInputOrigin(location.origin[0].label)
            var tmpInputOrigin = location.origin[0].label
        }
        else {
            setOrigin({ location_name: location.origin[0].label, location: { lon: location.origin[0].value[0], lat: location.origin[0].value[1], 'label': location.origin[0].label } })
            var tmpOrigin = { location_name: location.origin[0].label, location: { lon: location.origin[0].value[0], lat: location.origin[0].value[1], 'label': location.origin[0].label } }

            setInputOrigin(location.origin[0].label)
            var tmpInputOrigin = location.origin[0].label
        }

        // Validate whether user has requested for ALL location as a DESTINATION
        if (location.destination.length === 0) {
            var temp = []
            temp.push({ label: 'ALL', value: [] })
            location.destination = temp

            setDestination({ location_name: location.destination[0].label, location: { 'label': location.destination[0].label } })
            var tmpDestination = { location_name: location.destination[0].label, location: { 'label': location.destination[0].label } }

            setInputDestination(location.destination[0].label)
            var tmpInputDestination = location.destination[0].label
        }
        else {
            setDestination({ location_name: location.destination[0].label, location: { lon: location.destination[0].value[0], lat: location.destination[0].value[1], 'label': location.destination[0].label } })
            var tmpDestination = { location_name: location.destination[0].label, location: { lon: location.destination[0].value[0], lat: location.destination[0].value[1], 'label': location.destination[0].label } }

            setInputDestination(location.destination[0].label)
            var tmpInputDestination = location.destination[0].label
        }

        // Get results for specified origin and destination
        getResults(tmpOrigin, tmpInputOrigin, tmpDestination, tmpInputDestination)

    }

    const changeHandlerforPage = (e) => {
        TrackMixPanel({
            ModuleName: 'landing_page',
            ScreenName: 'LoRRI-Discovernow',
            Data: `Page ${e}`,
            Definition: 'User has clicked on pagination button'
        });
        setskipactive(e)
        if ((((e - 2) * 10) + 10) > nooftransporters) {
            setExhaushted(true)
        } else {
            setExhaushted(false)
            let request_data = getRequestData(origin,
                inputOrigin,
                destination,
                inputDestination,
                selectedFilters,
                selectedfield,
                (((e - 2) * 10) + 10),
                transitTime,
                preferredTruck)
            setShow(true);
            AxiosRequest(request_data)
                .then(res => {
                    if (res.data.transporter_list && res.data.transporter_list.length > 0) {
                        // let current_data = [...transporter_data, ...res.data.transporter_list];
                        settransporterData(res.data.transporter_list)
                    }
                    else {
                        setExhaushted(true)
                    }
                    setShow(false);
                })
                .catch(err => {

                    setShow(false)
                })
        }
    }
    // var transporter_list = []
    const getTransportersfortrucksavailable = (e) => {
        TrackMixPanel({
            ModuleName: 'landing_page',
            ScreenName: 'LoRRI-Discovernow',
            Data: JSON.stringify({ origin: inputOrigin, destination: inputDestination }),
            Definition: 'User has clicked get rates button'
        });
        let request_data = getRequestData(origin,
            inputOrigin,
            destination,
            inputDestination,
            selectedFilters,
            selectedfield,
            0,
            transitTime,
            preferredTruck,
            (((skipactive - 1) * 10) + 10)
        )
        setShow(true);
        AxiosRequest(request_data)
            .then(res => {
                if (res.data.transporter_list && res.data.transporter_list.length > 0) {
                    settransporterData(res.data.transporter_list)
                    document.getElementById('rates_modal').click();
                }
                setShow(false);
            })
            .catch(err => {
                setShow(false)
            })
    }

    return (
        !isMobile() ?
            <Container className={classes['mycontainer']}>
                <Loader show={show} />
                <Row className={`${classes['space-around']}`}>
                    <h3 style={{ color: 'white', fontSize: '20px', margin: 0 }}>DiscoverNow</h3>
                </Row>
                <Row className={`${classes['flex100']} ${classes['margin-top']}`}>
                    <Column className={classes['side-panel']}>
                        <Row style={{ width: '100%', margin: '1%', }}>
                            {/* marginTop:6% */}
                            <span style={{ color: "white", fontSize: '14px' }}>Search Credits: {isAllowed === 'yes' ? credits : 0}</span>
                        </Row>
                        <Row>
                            <Column style={{ width: '100%', margin: '1%' }}>
                                <label style={{ color: 'white', fontSize: '16px', fontWeight: '300' }}>From</label>
                                <div style={{ height: '38px' }}>
                                    <AutoComplete
                                        value={
                                            origin
                                                ? {
                                                    value: origin?.location?.location || inputOrigin,
                                                    label: origin?.location_name || inputOrigin
                                                }
                                                : inputOrigin
                                                    ? {
                                                        value: inputOrigin,
                                                        label: inputOrigin
                                                    }
                                                    : null
                                        }
                                        placeholder="Origin"
                                        className={classes['origin_input']}
                                        onChange={(val) => setInputOrigin(val)}
                                        onSelect={(obj) => setOrigin(obj)}
                                        searchFields='locations'
                                    //customStyles={classes['origin_input']}
                                    />
                                </div>
                            </Column>
                        </Row>
                        <Row>
                            <Column style={{ width: '100%', margin: '1%' }}>
                                <label style={{ color: 'white', fontSize: '16px', fontWeight: '300' }}>To</label>
                                <div style={{ height: '38px' }}>
                                    <AutoComplete
                                        key={"Destination_Key"}
                                        value={
                                            destination
                                                ? {
                                                    value: destination?.location?.location || inputDestination,
                                                    label: destination?.location_name || inputDestination
                                                }
                                                : inputDestination
                                                    ? {
                                                        value: inputDestination,
                                                        label: inputDestination
                                                    }
                                                    : null
                                        }
                                        placeholder="Destination"
                                        className={classes['origin_input']}
                                        onChange={(val) => setInputDestination(val)}
                                        onSelect={(obj) => setDestination(obj)}
                                        searchFields='locations'
                                    //customStyles={{}}   // optional, don’t pass class here
                                    />
                                </div>
                            </Column>
                        </Row>
                        <Row style={{ width: '100%', justifyContent: 'center', paddingBottom: '3%', borderBottom: '1px solid lightgrey' }}>
                            {credits === 0 ?
                                <UpgradeModal
                                    screenName="DiscoverNow"
                                    feature="Search Lane"
                                    moduleName="Search"
                                    activityName="Upgrade Popup"
                                    buttonClass="btn btn-success"
                                    buttonLabel={<span>
                                        <i className="fa fa-search" ></i> Search
                                    </span>}
                                    style={{ width: 'fit-content' }}
                                />
                                : <button className={`btn btn-success`} onClick={e => getResults(origin, inputOrigin, destination, inputDestination)} disabled={(inputOrigin && inputDestination) ? false : true}>
                                    <span>
                                        <i className="fa fa-search" ></i> Search
                                    </span>
                                </button>}
                        </Row>

                        {/* style={{width:'20%',justifyContent:'center',zIndex:'1', position:'absolute',bottom:'5%'}} */}
                        <Row style={{ marginTop: '4%', width: '100%', justifyContent: 'center' }}>
                            <Column style={{ justifyContent: 'center', width: '50%' }}>
                                <button disabled={transporterData.length === 0} className="btn btn-sm btn-success" onClick={e => getTransportersfortrucksavailable()}>
                                    Get Rates
                                </button>
                                <RatesModal
                                    screenName="Discover Now"
                                    moduleName="Get Rates"
                                    activityName={`Get Rates Button Clicked`}
                                    buttonLabel={'Get Rates'}
                                    content={<NewEnquiry
                                        discovernowbutton={true}
                                        rspl={[{ origin: origin, destination: destination, transporter_list: transporterData }]}
                                        onbackclick={e => changeHandlerforPage(skipactive)}
                                    />}
                                    id={'rates_modal'}
                                    // disabled={lspload}
                                    size='fullscreen'
                                    title={`My Enquiries`}
                                    buttonClass={`btn btn-sm btn-success`}
                                    style={{ display: 'none' }}
                                    overflowStyles={{ overflow: 'hidden' }}
                                    closeButtonId='close_contact'
                                />
                            </Column>
                            <Column style={{ justifyContent: 'center', marginLeft: '4%', width: '46%' }}>
                                <RatesModal
                                    screenName="Discover Now"
                                    moduleName="History"
                                    buttonClass="btn btn-sm btn-success"
                                    activityName={`View History button clicked`}
                                    buttonLabel={'View History'}
                                    title={`History`}
                                    content={
                                        <UserHistoryList
                                            userHistory={userHistory}
                                            historyArray={historyArray}
                                            populateLocations={populateLocations}
                                            TrackMixPanel={TrackMixPanel}
                                        />
                                    }
                                    disabled={userHistory && userHistory.length === 0}
                                    closeButtonId='closeHistoryPopup'
                                />
                                {/* <button className="btn btn-sm btn-success" onClick={e=>{
                                Activity([{ "screen": "DiscoverNow", "module": "History", "user_activity": 'View History button clicked', "timestamp": currentRequestTimeStamp() }])  
                                setShowHistory(!showHistory)}} style={{ fontWeight:'500', color:'white'}}>View History</button> */}
                            </Column>
                        </Row>
                        {/* <Row>
                        <Column style={{height:'30%', width:'100%', marginTop:'1%'}}>
                        
                        </Column>
                    </Row> */}
                    </Column>
                    <Column style={{ width: '80%', marginLeft: '1%', marginTop: '1%' }}>
                        <Row >
                            <Filters
                                skipactive={skipactive}
                                setskipactive={setskipactive}
                                selectedFilters={selectedFilters}
                                setSelectedFilters={setSelectedFilters}
                                selectedfield={selectedfield}
                                setSelectedfield={setSelectedfield}
                                selectedfieldfetched={selectedfieldfetched}
                                getTransportersList={getTransportersList}
                                availableFilters={availableFilters}
                                origin={origin}
                                field={fields}
                                destination={destination}
                                inputDestination={inputDestination}
                                inputOrigin={inputOrigin}
                                transitTime={transitTime}
                                preferredTruck={preferredTruck}
                                userType={userType}
                                isFilterAllowed={isFilterAllowed}
                            />
                        </Row>
                        <TransporterList
                            filters={selectedFilters}
                            transporter_data={transporterData}
                            origin={origin}
                            skipactive={skipactive}
                            fields={fields}
                            setFields={setFields}
                            isAllowed={isAllowed}
                            inputOrigin={inputOrigin}
                            inputDestination={inputDestination}
                            destination={destination}
                            total_count={totalCount}
                            credits={credits}
                            getDataOnLoadRequest={data => settransporterData(data)}
                            transitTime={transitTime}
                            preferredTruck={preferredTruck}
                            exhaushted={exhaushted}
                            setExhaushted={e => setExhaushted(e)}
                            policydata={policydata}
                            selectedfield={selectedfield}
                            setSelectedfield={setSelectedfield}
                            setSelectedFilters={e => setSelectedFilters(e)}
                            getTransportersList={requestData => getTransportersList(requestData)}
                            availableFilters={availableFilters}
                            userType={userType}
                            isFilterAllowed={isFilterAllowed}
                        />
                        <Row style={{ justifyContent: 'center' }}>
                            <Pagination
                                activePage={skipactive}
                                totalItemsCount={totalCount > nooftransporters ? nooftransporters : totalCount}
                                onChange={e => changeHandlerforPage(e)}
                                itemClass="page-item"
                                linkClass="page-link"
                                hideDisabled
                            />
                        </Row>
                    </Column>
                </Row>
            </Container> :

            <Container className={classes['Mobile-Container']}>
                {/* <Row className={classes['justify-content-space-evenly']}>
                <h3 className={classes['l-heading']}>DiscoverNow</h3>
            </Row> */}
                <Row className={`${classes['space-around']}`}>
                    <h3 style={{ color: 'white', fontSize: '20px', margin: 0 }}>DiscoverNow</h3>
                </Row>
                <Loader show={show} />
                <Row className={`${classes['justify-content-space-evenly']} ${classes['algin-items-center']} ${classes['margin-bottom-1per']}`}>
                    <span>
                        <b>
                            Search Credits:</b>
                        {credits}
                    </span>
                </Row>
                <Row>
                    <Column style={{ margin: '1%', width: '95%' }}>
                        <label style={{ fontSize: '16px', fontWeight: '300' }}>From</label>
                        <div style={{ height: '30px' }}>
                            <AutoComplete
                                value={
                                    origin
                                        ? {
                                            value: origin?.location?.location || inputOrigin,
                                            label: origin?.location_name || inputOrigin
                                        }
                                        : inputOrigin
                                            ? {
                                                value: inputOrigin,
                                                label: inputOrigin
                                            }
                                            : null
                                }
                                placeholder="Origin"
                                className={classes['origin_input']}
                                onChange={(val) => setInputOrigin(val)}
                                onSelect={(obj) => setOrigin(obj)}
                                searchFields='locations'
                            //customStyles={classes['origin_input']}
                            />
                        </div>
                        <label style={{ fontSize: '16px', fontWeight: '300', marginTop: '3%' }}>To</label>
                        <AutoComplete
                            key={"Destination_Key"}
                            value={
                                destination
                                    ? {
                                        value: destination?.location?.location || inputDestination,
                                        label: destination?.location_name || inputDestination
                                    }
                                    : inputDestination
                                        ? {
                                            value: inputDestination,
                                            label: inputDestination
                                        }
                                        : null
                            }
                            placeholder="Destination"
                            className={classes['origin_input']}
                            onChange={(val) => setInputDestination(val)}
                            onSelect={(obj) => setDestination(obj)}
                            searchFields='locations'
                        //customStyles={{}}   // optional, don’t pass class here
                        />
                    </Column>
                </Row>
                <Column style={{ width: '100%', justifyContent: 'center', paddingBottom: '3%', borderBottom: '1px solid lightgrey' }}>
                    <Row style={{ width: '100%' }}>
                        <center style={{ width: '100%' }}>
                            {credits === 0 ?
                                <UpgradeModal
                                    screenName="DiscoverNow"
                                    feature="Search Lane"
                                    moduleName="Search"
                                    activityName="Upgrade Popup"
                                    buttonClass="btn btn-success"
                                    buttonLabel={<span>
                                        <i className="fa fa-search" ></i> Search
                                    </span>}
                                    style={{ width: 'fit-content' }}
                                />
                                : <button className={`btn btn-success`} onClick={e => getResults(origin, inputOrigin, destination, inputDestination)} disabled={(inputOrigin && inputDestination) ? false : true}>
                                    <span>
                                        <i className="fa fa-search" ></i> Search
                                    </span>
                                </button>}
                        </center>
                    </Row>
                    <Row style={{ width: '100%', margin: '2%', justifyContent: 'space-around' }}>
                        <RatesModal
                            screenName="Discover Now"
                            moduleName="History"
                            buttonClass="btn btn-sm btn-success"
                            activityName={`View History button clicked`}
                            buttonLabel={'View History'}
                            title={`History`}
                            content={
                                <UserHistoryList
                                    userHistory={userHistory}
                                    historyArray={historyArray}
                                    populateLocations={populateLocations}
                                    TrackMixPanel={TrackMixPanel}
                                />
                            }
                            disabled={userHistory && userHistory.length === 0}
                        />
                        {/* <center style={{width:'100%'}}> */}
                        {/* <button className="btn btn-sm btn-success" 
                            onClick={e=>{
                                    Activity([{ "screen": "DiscoverNow", "module": "History", "user_activity": 'View History button clicked', "timestamp": currentRequestTimeStamp() }])  
                                    setShowHistory(!showHistory)}} style={{ fontWeight:'500', width:'30%',color:'white'}}>View History</button> */}
                        <button className="btn btn-sm btn-success" onClick={e => getTransportersfortrucksavailable()}>
                            Get Rates
                        </button>
                        <RatesModal
                            screenName="Discover Now"
                            moduleName="Get Rates"
                            activityName={`Get Rates Button Clicked`}
                            buttonLabel={'Get Rates'}
                            content={<NewEnquiry
                                discovernowbutton={true}
                                rspl={[{ origin: origin, destination: destination, transporter_list: transporterData }]}
                                onbackclick={e => changeHandlerforPage(skipactive)}
                            />}
                            id={'rates_modal'}
                            // disabled={lspload}
                            title={`My Enquiries`}
                            size='fullscreen'
                            buttonClass={`btn btn-sm btn-success`}
                            style={{ display: 'none' }}
                            overflowStyles={{ overflow: 'hidden' }}
                            closeButtonId='close_contact'
                        />
                        {/* </center> */}
                    </Row>
                </Column>
                <Row style={{ width: '100%' }}>
                    <center style={{ width: '100%' }}>
                        <button className="btn btn-sm btn-primary" style={{ width: '90%' }} onClick={e => {
                            TrackMixPanel({
                                ModuleName: 'landing_page',
                                ScreenName: 'LoRRI-Discovernow',
                                Data: `${!showFilters}`,
                                Definition: 'User has clicked filters toggle button'
                            })
                            setShowFilters(!showFilters)
                        }}>Filters</button>
                    </center>
                </Row>


                {showFilters ? <Row style={{ padding: '3%', borderBottom: '1px solid whitesmoke' }}>
                    <Filters
                        skipactive={skipactive}
                        setskipactive={setskipactive}
                        selectedFilters={selectedFilters}
                        setSelectedFilters={setSelectedFilters}
                        selectedfield={selectedfield}
                        setSelectedfield={setSelectedfield}
                        selectedfieldfetched={selectedfieldfetched}
                        getTransportersList={getTransportersList}
                        availableFilters={availableFilters}
                        origin={origin}
                        field={fields}
                        destination={destination}
                        inputDestination={inputDestination}
                        inputOrigin={inputOrigin}
                        transitTime={transitTime}
                        preferredTruck={preferredTruck}
                        userType={userType}
                        isFilterAllowed={isFilterAllowed}
                    />
                </Row> : null}

                <Column>
                    <TransporterList
                        filters={selectedFilters}
                        transporter_data={transporterData}
                        origin={origin}
                        fields={fields}
                        skipactive={skipactive}
                        setFields={setFields}
                        isAllowed={isAllowed}
                        inputOrigin={inputOrigin}
                        inputDestination={inputDestination}
                        destination={destination}
                        total_count={totalCount}
                        credits={credits}
                        getDataOnLoadRequest={data => settransporterData(data)}
                        transitTime={transitTime}
                        preferredTruck={preferredTruck}
                        exhaushted={exhaushted}
                        setExhaushted={e => setExhaushted(e)}
                        policydata={policydata}
                        selectedfield={selectedfield}
                        setSelectedfield={setSelectedfield}
                        setSelectedFilters={e => setSelectedFilters(e)}
                        getTransportersList={requestData => getTransportersList(requestData)}
                        availableFilters={availableFilters}
                        userType={userType}
                        isFilterAllowed={isFilterAllowed}
                    />
                </Column>
                <Row style={{ justifyContent: 'center' }}>
                    <Pagination
                        activePage={skipactive}
                        totalItemsCount={totalCount > nooftransporters ? nooftransporters : totalCount}
                        onChange={e => changeHandlerforPage(e)}
                        itemClass="page-item"
                        linkClass="page-link"
                        hideDisabled
                    />
                </Row>
            </Container>

    )
}

export default DiscoverNow
